import './index.scss';

import { Component, ReactNode } from 'react';
import { Field, FieldProps } from 'formik';

import t from 'utils/i18n';
import { BraxIcon } from 'components/BraxIcon';

export type BraxFieldGroupProps = {
    name: string,
    label?: ReactNode,
    hint?: ReactNode,
    children: ReactNode
};

export class BraxFieldGroup extends Component<BraxFieldGroupProps> {

    render() {
        return (
            <Field name={this.props.name}>
                { (formik: FieldProps) => {
                    const hasError = formik.meta.touched && formik.meta.error !== undefined && typeof formik.meta.error !== 'object';

                    return (
                        <div className={`brax-field-group ${hasError ? 'error' : ''}`}>
                            { this.props.label ? <p className="complementary-title">{ this.props.label }</p> : null }

                            { this.props.hint ? (
                                <p className="hint">{ this.props.hint }</p>
                            ) : null }

                            { this.props.children }

                            { hasError ? (
                                <p className="hint">
                                    <BraxIcon icon="exclamation-mark" />

                                    <span>{ t(formik.meta.error) }</span>
                                </p>
                            ) : null }
                        </div>
                    );
                } }
            </Field>
        );
    }

}
